/**
 * 图片上传 API 路径
 */
export const IMAGE_UPLOAD_API_PATHS = {
    /** 批量上传图片 */
    BATCH_UPLOAD: '/image-upload/batch',
    /** 批量获取文件签名地址 */
    SIGN_FILES: '/image-upload/sign',
} as const;

/**
 * 默认文件夹路径
 */
export const DEFAULT_IMAGE_FOLDER_PATH = 'ai_specification/image';

/**
 * 默认文件名前缀
 */
export const DEFAULT_IMAGE_FILE_PREFIX = 'image';
